import React from 'react';
import PropTypes from 'prop-types';

import SupportRequestPresenter from '../../../../presenters/SupportRequestPresenter';
import { useFetchStatus } from '../../../../utils/fetchStatusUtils';
import ListSkeleton from '../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../pages/constants';

import RequestInfo from './components/RequestInfo';
import UserInfo from './components/UserInfo';
import TransactionInfo from './components/TransactionInfo';
import AdditionalInfo from './components/AdditionalInfo';

const SupportRequest = (props) => {
  const { request, loadingStatus, onEditModalOpen } = props;
  const { isFulfilled } = useFetchStatus(loadingStatus);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  const user = SupportRequestPresenter.user(request);

  return (
    <div>
      <RequestInfo request={request} />
      <UserInfo user={user} />
      <TransactionInfo request={request} />
      <AdditionalInfo request={request} onEditModalOpen={onEditModalOpen} />
    </div>
  );
};

export default SupportRequest;

SupportRequest.propTypes = {
  request: SupportRequestPresenter.shape(),
  loadingStatus: PropTypes.string.isRequired,
  onEditModalOpen: PropTypes.func.isRequired,
};

SupportRequest.defaultProps = {
  request: null,
};
